module.exports = __webpack_public_path__ + "img/b_03.962537f7.png";